module.exports = __webpack_public_path__ + "img/is_get.277dff7.png";